import { Fragment } from 'react';

import Buttons from '@klv/molecules/buttons';
import MixedMedia from '@klv/molecules/mixed-media';
import useSlides from '@klv/hooks/useSlides';
import { generateClassName } from '@klv/shared/utils/functions';

import * as s from './styles/twoColumnSlider.module.scss';

import type { ITwoColumnSlider, ITwoColumnSliderRow, TAnimationName } from './types';

const getAnimationClassName = (slide: ITwoColumnSliderRow): TAnimationName => {
  const animationName = ['slide'];
  if (slide.$dir === 'left') {
    animationName.push(slide.$current ? 'InLeft' : 'OutLeft');
  } else {
    animationName.push(slide.$current ? 'InRight' : 'OutRight');
  }
  return animationName.join('') as TAnimationName;
};

const TwoColumnSlider = ({ rows }: ITwoColumnSlider) => {
  const { slides, setThisSlide, swipeable } = useSlides(rows, ['left', 'right']);

  return (
    <div
      className={
        generateClassName([
          s.twoColumnSlider,
          'defaultPaddingTop',
          'defaultPaddingBottom',
        ])}
        {...swipeable}
      >
      <div className={generateClassName([s.grid, 'grid'])}>
        <div className={s.menu}>
          {(rows.map((row, rowIndex) => (
            <button
              className={
                generateClassName([
                  s.menuButton,
                  slides[rowIndex].$current && s.current,
                  ''
                ])}
              {...slides[rowIndex]}
              key={row.menuItem}
              onClick={() => { setThisSlide(rowIndex); }}
              type="button"
            >
              {row.menuItem}
            </button>
          )))}
        </div>
        {slides.map((slide: ITwoColumnSliderRow) => (
          <Fragment key={slide.headline}>
            <div
              className={
                generateClassName([
                  s.twoColumnSliderText,
                  slide.$current && s.current
                ])
              }
            >
              {slide.headline && <div className={generateClassName([s.headline, 'h3'])}>{slide.headline}</div>}
              <div className={generateClassName([s.bodyText, 'p2'])} dangerouslySetInnerHTML={{ __html: slide.body }} />
              {slide?.buttons && <Buttons buttons={slide.buttons} variants={['ghost', 'tertiary']} buttonColor="light" />}
            </div>
            <div
              className={
                generateClassName([
                  s.imageContainer,
                  slide.$current && s.current,
                  s[getAnimationClassName(slide)]
                ])
              }
            >
              <MixedMedia mixedMedia={slide.mixedMedia} />
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default TwoColumnSlider;
